
<script>
import inputEventBus from '@/mixins/input-eventbus';
export default {
    props: {
        baseEndpointDomain: {
            type: String,
            default: ''
        },
        dropdownController: {
            type: String,
            required: true
        },
        dropdownDynamic: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            coursetopic: null,
            coursetype: null,
            children: [],
            selectedTopic: '',
            errorMsg: 'No list found!',
            isError: false,
            showDynamicDropdown: false
            
        }
    },
    mounted() {
        this.$children.forEach(vNode => {
            vNode.$children.forEach( vNode => {
                // Course Type/Format - Dynamic
                if(vNode.$vnode.componentOptions.propsData.inputName === this.dropdownDynamic) {
                    this.coursetype = vNode;
                        this.$nextTick(() => {
                            this.resetCourseTypeList();
                        });
                }
                // Course Topic - Controller to fetch from API to generate Course Type dropdown list
                if(vNode.$vnode.componentOptions.propsData.inputName === this.dropdownController) {
                    this.coursetopic = vNode;
                        this.$nextTick(() => {
                            // console.log('COURSETOPIC DROPDOWN: ', this.coursetopic);
                            this.coursetopic.$on('selected', this.listenToInput)
                        });
                }

            })
        })
        
    },
    methods: {
        listenToInput(value, text, el) {
                if(value !== '') {
                    if(this.selectedTopic !== text) {
                        let endpoint = el.getAttribute('data-endpoint');
                        this.fetchData(endpoint);
                        this.selectedTopic = text;
                    }
                } else {
                    this.resetCourseTypeList();
                }
            
        },
        fetchData(endpoint) {
            // test locally
            // let _endpoint = this.baseEndpointDomain + endpoint;
            // production
            let _endpoint = this.baseEndpointDomain + '?' + 'topicId=' + endpoint;
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let requestOptions = {
                method: "POST",
                headers: myHeaders
            };

            fetch(_endpoint, requestOptions)
                .then(response => {
                    if (response.ok) {
                        this.isError = false;
                        this.showDynamicDropdown = true;
                        response.json().then(data => {
                        this.children = data;
                        });
                    } else {
                        throw Error(response.status + ' ' + response.statusText);
                    }
                })
                .catch((error) => {
                this.resetCourseTypeList();
                this.isError = true;
                });
        },
        resetCourseTypeList() {
            this.coursetype.resetList(0)
            this.children = [];
        }
    },
    render() {
        return this.$scopedSlots['dynamicdropdowns']({
            children: this.children,
            error: this.errorMsg,
            isError: this.isError,
            showDynamicDropdown: this.showDynamicDropdown
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/app/components/aha-cpr-search-course-wrapper.vue